import { render, staticRenderFns } from "./modal_analistasDesignados-supervisor.vue?vue&type=template&id=547f73f8&"
import script from "./modal_analistasDesignados-supervisor.vue?vue&type=script&lang=js&"
export * from "./modal_analistasDesignados-supervisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports